import { LATEST_ELECTRONIC_SIGNING_URL } from '@app/constants/terms';
import { CONTRACT_PROGRESS_TERMS_URL_LOAD_SUCCESS } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressTermOfUseUrlState = string;

const initialState: ContractProgressTermOfUseUrlState = LATEST_ELECTRONIC_SIGNING_URL;

export default function reducer(
  state: ContractProgressTermOfUseUrlState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_TERMS_URL_LOAD_SUCCESS:
      return action.payload.termOfUseURL;
    default:
      return state;
  }
}
